// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Mo-z","breadcrumbForward":"No-z","breadcrumbBack":"Oo-z","selected":"Po-z"};